module.exports = __webpack_public_path__ + "static/p12_H_vaca-4ba140a360bfc55d289de221101dc382.png";